export default "__VITE_ASSET__Bh57z1k0__"